<template>

    <a href="javascript:void(0)" class="btn btn-sm btn-primary" @click="showFileManager()">{{ buttonText }}</a>

</template>

<script>
    export default {
        props: ['basePath', 'buttonText', 'disableWriteAccess'],
        data() {
            return {
                eventHub: window.eventHub
            }
        },
        methods: {
            showFileManager() {
                this.eventHub.$emit('show-file-manager', this._uid, 'browse', '*', this.basePath, this.disableWriteAccess)
            }
        },
        mounted() {

        }
    };
</script>
